import { useQuery } from "@tanstack/react-query";
import { getRegion } from "../services/get-region";

export function useRegion(id?: string) {
  return useQuery({
    queryKey: ["region", id],
    queryFn: () => getRegion(id as string),
    enabled: Boolean(id),
  });
}
